module.exports = __webpack_public_path__ + "img/U1F438.4ab38e35.png";